/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-04-15T17:15:33.308
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getReportMonthRentHouseBigEditInit,
	getReportMonthRentHouseBigView
} from '@api/report/ReportMonthRentHouseBig';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getReportMonthRentHouseBigEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportMonthRentHouseBigEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getReportMonthRentHouseBigView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getReportMonthRentHouseBigView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
